import React from 'react';
import { triggerSentryError } from '../../utils';


class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.log(error, errorInfo);
    triggerSentryError(`Error at ${window.location.href}. Error message: ${errorInfo.componentStack}`)
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className="container login-page">
          <div className="row justify-content-center">
            <div className="col-12 col-md-8 col-lg-6 col-xl-4 login-form alert alert-danger">
              <h4>Villa kom upp.</h4>
              <p>Villa kom um upp við að hlaða þessari síðu. Vinsamlegast endurhlaðið síðunni og reynið aftur. Ef villan endurtekur sig þá vinsamlegast hafðu samband við Allianz á Íslandi.</p>
            </div>
          </div>
        </div>
      )
    }
    return this.props.children; 
  }
}

export default ErrorBoundary